<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				 <!-- 筛选 -->
				 <div class="searchblock">
						<search></search>
				</div>
				 
				 <!-- 分类/类别 -->
				 <div class="categoryContent">
					 <ul class="d-flex">
						 <li @click="goToPage(item.url)" v-for="(item, index) in categoryList" :key="index">
							 <div class="text d-flex pointer t-sion">
								 <figure><img :src="item.imageUrl" alt=""></figure>
								 <div class="desc">
									 <h4 class="font20 cor265">{{$store.state.lang == 'zh_CN' ? item.title : item.enTitle}}</h4>
									 <p class="font14 cor999" v-show="$store.state.lang == 'zh_CN'">{{item.enTitle}}</p>
								 </div>
							 </div>
						 </li>
					 </ul>
				 </div>
				 
				 <!-- 最新产品 /最新文档 /最新培训  -->
				 <div class="productAndDocument d-flex">
					 <!-- 最新产品 -->
					 <div class="pSlide">
						 <div class="sTitle d-flex a-center j-sb">
							 <h3 class="font24"><img src="@/assets/Icons/newProduct.png" alt="">{{$t('show.newProduct')}}</h3>
							 <a class="link font-light" @click="goToPage('/product')" href="javascript:;">{{$t('show.more')}} &gt;</a>
						 </div>
						 <div class="text conmonProduct newProduct">
							 <ul>
								 <li @click="goToPage('/productDirectory?productId='+item.productId)" class="pointer" v-for="(item, index) in contentList.versionList" :key="index">
									 <div class="pt d-flex j-sb">
										 <div class="ptL">
											 <h3 class="font18 font-medium h3"><a class="link pointer">{{item.name}}</a></h3>
											 <p class="font-light line-sm">{{item.description}}</p>
										 </div>
										 <strong class="font18 font-medium">{{item.no}}</strong>
									 </div>
									 <div class="tags d-flex j-sb">
										 <div class="tagList d-flex f-wrap">
											 <i class="font14" v-for="(item2, index2) in item.tag ? item.tag.split(',') : []" :key="index2">{{item2}}</i>
										 </div>
										 <span class="font14 cor999">{{item.time}}</span>
									 </div>
								 </li>
							 </ul>
						 </div>
					 </div>
					 <!-- 最新文档 -->
					 <div class="pSlide">
						 <div class="sTitle d-flex a-center j-sb">
							 <h3 class="font24"><img src="@/assets/Icons/newDocument.png" alt="">{{$t('show.newDocument')}}</h3>
							 <a class="link font-light" @click="goToPage('/document')" href="javascript:;">{{$t('show.more')}} &gt;</a>
						 </div>
						 <div class="text conmonDocument newDocument">
							 <ul>
								 <li class="pointer" v-for="(item, index) in contentList.documentList" :key="index">
									 <div class="pt d-flex j-sb">
										 <h3 class="font18 font-medium pdf h3"><a class="link">{{item.title}}</a></h3>
										 <div class="lir">
											<span class="font14 font-light cor999">{{item.fileSize}}</span>
											<div class="rHandle d-flex a-center">
												<a  class="d" @click="downloadFile(item.id,index)"></a>
												<a  class="l" v-if="item.fileSuffix=='pdf'" @click="viewFile(item.id,index)"></a>
											</div>
											<div class="downbar d-flex j-end" v-show="item.dp>0">
												<el-progress :percentage="item.dp" :show-text="true" :stroke-width="4"></el-progress>
											</div>
										 </div>
										 
									 </div>

								 </li>
							 </ul>
						 </div>
					 </div>
					 <!-- 最新培训  -->
					 <div class="pSlide">
						 <div class="sTitle d-flex a-center j-sb">
							 <h3 class="font24"><img src="@/assets/Icons/newTrain.png" alt="">{{$t('show.newTrain')}}</h3>
							 <a class="link font-light" @click="goToPage('/onlineTrain')" href="javascript:;">{{$t('show.more')}} &gt;</a>
						 </div>
						 <div class="text newTrain">
							 <ul>
								 <li @click="goToPage('/onlineTrainDetail?id='+item.id)" :class="['pointer d-flex a-center pointer', {notImg: index == 1 ? true : false}]"  v-for="(item, index) in contentList.trainList" :key="index">
									 <figure>
										 <img :src="item.cover" class="w100 t-sion" :alt="item.title">
									 </figure>
									 <div class="pt d-flex f-colu">
										 <h3 class="font18 font-medium h3"><a class="link">{{item.title}}</a></h3>
										 <span class="font14 font-light cor999">{{item.releaseDate}}</span>
									 </div>
								 </li>
							 </ul>
						 </div>
					 </div>
				 </div>
				 
				 <!-- 最新活动 -->
				 <div class="newActivityList">
					 <div class="sTitle d-flex a-center j-sb">
						 <h3 class="font24"><img src="@/assets/Icons/newActivity.png" alt="">{{$t('show.newActivity')}}</h3>
						 <div class="rightMenu d-flex a-center">
							<!-- <div class="sMenu font18">
								<a href="javascript:;" class="link">活动类别1</a>
								<a href="javascript:;" class="link">活动类别2</a>
								<a href="javascript:;" class="link">活动类别3</a>
							</div> -->
							<a class="link font-light" @click="goToPage('/activity')" href="javascript:;">{{$t('show.more')}} &gt;</a>
						 </div>
					 </div>
					 <div class="naList">
						 <ul class="d-flex f-wrap">
							 <li class="pointer" v-for="(item, index) in contentList.activityList" :key="index">
								 <div class="text scale">
									 <figure class="pointer pr">
										<a v-if="item.applyType == 1" class="entry pointer">{{$t('show.noStart')}}</a>
										<a v-if="item.applyType == 2" class="entry pointer">{{$t('show.entrying')}}</a>
										<a v-if="item.applyType == 3" class="entry gray">{{$t('show.end')}}</a>
										<img :src="item.cover" class="t-sion" :alt="item.title">
									 </figure>
									 <div class="intro">
										 <h3 class="nowrap2 h3 font20 font-medium line-sm"><a class="link">{{item.title}}</a></h3>
										 <p class="nowrap1 cor999 font-light">{{item.description}}</p>
										 <div class="date1 line-sm"><span>{{$t('show.activityDate')}}:</span>{{item.time}}</div>
										 <div class="date2 line-sm"><span>{{$t('show.registrationDate')}}:</span>{{item.applyBeginDate+'-'+item.applyEndDate}}</div>
										 <div class="type line-sm" v-if="item.activityType"><span>{{$t('show.activityType')}}:</span>{{item.activityType==1?$t('show.offlineActivity'):$t('show.onlineActivity')}}</div>
										 <div class="handel d-flex j-sb a-center" v-if="item.activityLink">
											 <div class="btns d-flex">
												<a :href="item.activityLink" target="_blank" class="lookDetail pointer">{{$t('show.lookDetail')}}</a>
											 </div>
										 </div>
									 </div>
								 </div>
							 </li>
						 </ul>
					 </div>
				 </div>
			</div>
		</div>
		<el-dialog
			:title="pdfView.title"
			:visible.sync="pdfView.showPdf"
			:fullscreen="true"
			class="pdfdialog"
			top="0"
			width="100%">
			<div class="pdfview">
				<div class="pdfview">
					<pdf v-for="i in pdfView.pages"
						:key="i"
						:src="pdfView.pdfBlob"
						:page="i">
					</pdf>
				</div>
			</div>
		</el-dialog>
  </div>
</template>

<script>
import { pdfjs, Document } from 'pdfjs-dist/build/pdf';
import VuePDF from 'vue-pdf';
export default {
  name: 'LoginHome',
  components: {
    pdf: VuePDF
  },
  data() {
    return {
		// 类别
		categoryList: [
			{id: 1, title: this.$t('topMenu.documentDownload'), imageUrl: require('@/assets/Icons/document.png'), enTitle: 'Documentation', url: '/document'},
			{id: 2, title: this.$t('topMenu.frequentlyAskedQuestion'), imageUrl: require('@/assets/Icons/question.png'), enTitle: 'Q & A', url: '/question'},
			{id: 3, title: this.$t('topMenu.operationTraining'), imageUrl: require('@/assets/Icons/handel.png'), enTitle: 'Training', url: '/onlineTrain'},
			{id: 4, title: this.$t('show.newProduct'), imageUrl: require('@/assets/Icons/product.png'), enTitle: 'New Products', url: '/product'},
			{id: 5, title: this.$t('adminMenu.feedback'), imageUrl: require('@/assets/Icons/feedback.png'), enTitle: 'Feedback', url: '/feedback'}
		],
		// 列表
		contentList: [],
		pdfView:{
			title:"",
			pages:undefined,
			pdfBlob:null,
			showPdf:false
		}
	}
  },
  
  created() {
	  // 获取文档
	  this.getDocumentVOList();
	  // 获取培训
	  this.getTrainVOList();
	  // 获取活动
	  this.getActivityVOList();
	  // 获取内容
	  this.getContentList();
  },
  
  methods: {
	viewFile(id,index){
		var that=this;
		if(that.contentList.documentList[index].blob!=''){
			that.pdfView.pdfBlob=that.contentList.documentList[index].blob;
			let loadingTask = VuePDF.createLoadingTask(that.pdfView.pdfBlob);
			loadingTask.promise.then(pdf => {
				that.pdfView.pages = pdf.numPages;
			});
			that.pdfView.title=that.contentList.documentList[index].title;
			that.pdfView.showPdf=true;
			return;
		};
		const loading = that.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
		that.$daxios
			.get(`knowledge/downLog?id=${id}`,{
			 	responseType: 'blob'
			})
			.then((res) => {
			loading.close();
			if(res.data&&res.data.size==0){
				that.$message({
					message:"下载失败",
					type: 'error'
				});
				return;
			};
			const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
			that.pdfView.pdfBlob=url;
			let loadingTask = VuePDF.createLoadingTask(that.pdfView.pdfBlob);
			loadingTask.promise.then(pdf => {
				that.pdfView.pages = pdf.numPages;
			});
			that.pdfView.title=that.contentList.documentList[index].title;
			that.pdfView.showPdf=true;
			})
			.catch((err) => { 
				loading.close();
				that.$message({
					message: '下载失败',
					type: 'warning'
				});
			});
	},
	downloadFile(id,index){
      var that=this;
      if(that.contentList.documentList[index].dp!=0){return;}
      that.$daxios
        .get(`knowledge/downLog?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.contentList.documentList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
		if(res.data&&res.data.size==0){
            that.contentList.documentList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
		  that.contentList.documentList[index].blob=url;
          const link = document.createElement('a');
          let fileName = res.headers['content-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
		  that.contentList.documentList[index].dp=0;
        })
        .catch((err) => {
			that.$message({
              message:"下载失败",
              type: 'error'
            })
          that.contentList.documentList[index].dp=0;
        });
    },
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
	  
	  // 页面跳转，新窗口打开
	  // goToPageOpen(path, param={}) {
		 //  let routeUrl = this.$router.resolve({
		 //  	  path: path,
		 //  	  query: param
		 //   });
		 //   window.open(routeUrl.href, '_blank');
	  // },
	  
	  
	  // 获取内容
	  getContentList() {
		  this.$axios.get('index/after/content')
		  .then(res => {
			res.data.documentList.forEach(i=>{i.dp=0;i.blob="";});
			  this.contentList = res.data;
		  })
		  .catch(err => {})
	  },
	  
	  
	  // 获取文档
	  getDocumentVOList() {
		  this.$axios.post('knowledge/documentPage', {pageSize: 7 })
		  .then(res => {
			  this.documentVOList = res.data.list;
		  })
		  .catch(err => {})
	  },
	  
	  // 获取培训
	  getTrainVOList() {
		  this.$axios.post('knowledge/trainPage', {pageSize: 4 })
		  .then(res => {
			  this.trainVOList = res.data.list;
		  })
		  .catch(err => {})
	  },
	  
	  // 获取活动
	  getActivityVOList() {
		  this.$axios.post('activity/page', {pageSize: 4 })
		  .then(res => {
			  this.activityVOList = res.data.list;
		  })
		  .catch(err => {})
	  }
  }
}
</script>

<style lang="less" scoped>
.rHandle{
	.d{
		width: .16rem;
		height: .16rem;
		background: url(@/assets/Icons/downloadGray.png) no-repeat center/100% 100%;
		margin-right: .2rem;
		&:hover{
			background-image: url(@/assets/Icons/downloadBlue.png);
		}
	}
	.l{
		width: .2rem;
		height: .15rem;
		background: url(@/assets/Icons/look.png) no-repeat center/100% 100%;
		&:hover{
			background-image: url(@/assets/Icons/lookBlue.png);
		}
	}
}
.naList{
	ul{
		li{
		.text{
			figure{
				padding-bottom: 55.44%;
				img{
					position: absolute;
					left: 0;
					top: 0;
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
		}
			.date1{
				span{
					display: block;
				}
			}
			.date2{
				span{
					display: block;
				}
			}
		}
		@media (max-width:768px) {
			li{
				width: 100%;
			}
		}
	}
}
.searchblock{
	margin: 0.5rem auto;
}
	.categoryContent{
		ul{
			margin: 0 -5px;
			li{
				width: 25%;
				padding: 0 5px;
				&:hover .text{
					transform: translateY(-5px);
					box-shadow: 2px 2px 2px rgba(0,0,0,.1);
				}
				.text{
					background: #fff;
					border-radius: .1rem;
					padding: .2rem .3rem;
				}
				figure{
					margin-right: 0.35rem;
				}
				img{
					width: .25rem;
				}
				p{
					margin-top: 0.05rem;
				}
			}
		}
		@media (max-width: 1200px) {
			ul{
				flex-wrap: wrap;
				margin-top: -.1rem;
				li{
					width: 33.33%;
					margin-top: .1rem;
				}
			}
		}
		@media (max-width: 640px) {
			ul{
				li{
					width: 50%;
				}
			}
		}
	}
	.productAndDocument{
		margin: 0 -0.1rem;
		margin-top: .6rem;
		.pSlide{
			width: 33.333%;
			padding: 0 0.1rem;
			.text{
				background: #fff;
				border-radius: 0.1rem;
				padding: .3rem;
				padding-top: .1rem;
				height: calc(100% - .6rem);
			}
		}
		@media (max-width: 1200px) {
			flex-wrap: wrap;
			.pSlide{
				width: 100%;
				margin-bottom: .3rem;
				&:last-child{
					margin-bottom: 0;
				}
			}
		}
	}
	.conmonDocument{
		ul li{
			padding: .25rem 0;
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			h3{
				width: 85%;
			}
			.lir{
				flex: 0 0 auto;
				text-align: right;
				.rHandle{
					margin-top: .1rem;
					justify-content: flex-end;
					a{
						&:last-child{
							margin-right: 0;
						}
					}
				}
			}
		}
	}
	.conmonProduct{
		ul li{
			padding: .2rem 0;
			border-bottom: solid 1px #f1f1f1;
			&:last-child{
				border-bottom: 0;
			}
			&:hover h3 a{
				color: #2147d7;
			}
		}
		.ptL,
		.tagList{
			width: 70%;
		}
		.tags{
			margin-top: .15rem;
			span{
				padding-top: 0.05rem;
			}
		}
	}
	.newTrain{
		ul li{
			padding: .25rem 0;
			&:not(:last-child) {
				border-bottom: solid 1px #f1f1f1;
			}
			&:hover{
				img{
					transform: scale(1.05);
				}
				a{
					color: #2147d7;
				}
			}
			figure{
				width: 1.6rem;
				border-radius: 3px;
				overflow: hidden;
			}
			.pt{
				width: calc(100% - 1.6rem);
				padding-left: .2rem;
				h3{
					margin-bottom: .15rem;
				}
			}
			&.notImg{
				figure{
					display: none;
				}
				.pt{
					width: 100%;
					padding: 0;
				}
			}
		}
	}
	.newActivityList{
		margin-top: .6rem;
		.sMenu a{
			margin-right: .45rem;
		}
		@media (max-width: 640px) {
			.sTitle{
				position: relative;
				.sMenu{
					position: absolute;
					left: 0;
					bottom: 0;
					z-index: 2;
				}
			}
		}
	}
</style>
